<template>
	<div class="bg-wrap full-height" :class="$skin.name">
		<Loading
			v-if="is_loading"
		></Loading>
		<div
			v-if="is_ready"
			class="full-height"
		>
			<Side
				v-if="is_side"
				:user="user"
				:shop_info="shop_info"
				:category="category"

				@toggleSide="toggleSide"
				@push="toLocation"
			>
			</Side>
			<div class="container full-height flex-column">
				<Top
					v-if="!program.not_top"
					:program="program"
					:user="user"
					:shop_info="shop_info"

					@toggleSide="toggleSide"
					@push="toLocation"
				></Top>

				<hr v-if="false && program.top_line" class="under-line mb-50-pc mb-20-m"/>

				<Title
					v-if="program.title"
					:program="program"
					:cart_cnt="cart_cnt"

					@push="toLocation"
				></Title>

				<SubTop
					v-if="is_sub_top"
					:user="user"
					:codes="codes"
				></SubTop>

				<router-view
					:cart_info="cart_items"
					:user="user"
					:key="$route.fullPath"
					:codes="codes"
					:is_mobile="is_mobile"

					@getCartList="getCartList"
					@onLoad="setProgram"
					class="contents"
				>
				</router-view>
				<Quick
					v-if="!program.not_quick"
					:user="user"
				></Quick>

				<SubBottom
					v-if="is_sub_bottom"
					:user="user"
				></SubBottom>

				<Bottom
					v-if="program.bottom"

					:user="user"
					:shop_info="shop_info"
					:cart_cnt="cart_cnt"
					@push="toLocation"
					@toggleSide="toggleSide"
				></Bottom>
			</div>
		</div>

		<Popup v-if="false"></Popup>

		<Notify
			:msg="notifyCondition.message"
			:type="notifyCondition.type"

			@clearMsg="clearMsg"
		/>

		<PersonalConfirm
			:user="user"
		></PersonalConfirm>

		<PopupConfirm
			v-if="is_on_grade"

			:not_cancel="true"
			@click="postGradeConfirm"
			@cancel="postGradeConfirm"
		>

			<template
				v-slot:title
			>회원 등급 변경 안내</template>
			<template
				v-slot:main-txt
			> [{{ last_grade.code_name }}] 회원 등급이 변경 되었습니다. </template>

		</PopupConfirm>
	</div>
</template>

<script>

	import Notify from '@/components/AlertMsg'
	import Side from "@/view/Layout/Side";
	import Top from "@/view/Layout/Top";
	import Bottom from "@/view/Layout/Bottom";
	import Title from "@/view/Layout/Title";
	import Loading from "@/view/Layout/Loading";
	import SubTop from "@/view/Layout/SubTop";
	import SubBottom from "./SubBottom";
	import Popup from "@/view/Layout/Popup";
	import PersonalConfirm from "./PersonalConfirm";
	import PopupConfirm from "./PopupConfirm";
	import Quick from "./Quick";
	
	export default{
		name: 'Layout'
		,props: ['user', 'shop_info', 'codes', 'category_list']
		,components: {
			Quick,
			PopupConfirm, PersonalConfirm, Popup, SubBottom, SubTop, Loading, Title, Bottom, Side, Top, Notify }
		,data: function(){
			return {
				program: {
				}
				,notifyCondition: {
					message: '메시지 입니다'
					,type: ''
				}
				,is_side: false
				,cart_items: [

				]
				,is_loading: true
				,is_ready: false
				,category: null
				, is_on_grade: false
				, is_mobile: this.$common.isMobile()
			}
		}
		,computed:{
			cart_cnt: function(){
				return this.cart_items.length
			}
			, is_sub_top: function(){
				let t = false
				if(this.$route.path.indexOf('Account') > -1){
					t = true
				}
				return t
			}
			, is_sub_bottom: function(){
				let t = false
				if(this.$route.path.indexOf('Account') > -1){
					t = true
				}
				return t
			}
			, last_grade: function(){
				let t = ''

				if(this.is_on_grade){
					this.codes.M001.items.filter( (grade) => {
						if(grade.code_index == this.user.member_level ) {
							t = grade
						}
					})
				}

				return t
			}

	}
		,methods: {

			getData: async function(){
console.log('layout getdata')
				this.is_loading = false
				let path = this.$route.fullPath
				if(this.user.member_id || path.indexOf('Auth') > -1 || path == '/'){
					console.log('is_ready', this.is_ready)
					this.is_ready = true
				}
			}
			,setNotify: function({type, message}){
				this.notifyCondition = {
					message: message
					,type: type
				}
			}
			,clearMsg: function(){
				this.notifyCondition.message = ''
			}
			,toggleSide: function(){
				this.is_side = !this.is_side
			}
			,setProgram: function(program){
				this.program = program
			}
			,toBack: function(){
				this.$router.back()
			}
			, toLocation: function( {name, params, query}){
				this.$router.push({ name: name, params: params, query: query}).catch(function(e){
					console.log(e)
				});
			}
			,onLoading: function(){
				this.is_loading = true
			}
			,offLoading: function(){
				setTimeout(() => {
					this.is_loading = false
				}, 300)
			}
			,getCartList: async function(){
				try{
					const result = await this.$request.init({
						method: 'get'
						,url: 'order/getCartList'
					})

					if(result.success){
						this.cart_items = result.data.content.result
					}else{
						this.$bus.$emit('notify', { type: 'error', message: result.message})
					}
				}catch (e) {
					console.log(e)
				}
			}
			, onGrade: function(){

				// console.log('this.user.last_grade', this.user.last_grade)
				this.is_on_grade = false
				if(this.user.last_grade){
					let history = JSON.parse(this.user.last_grade.history)
					if(history.grade != history.old && !history.confirm){
						this.is_on_grade = true
					}
				}
			}
			, postGradeConfirm: async function(){
				try{
					let history = this.user.last_grade
					let uid = history.uid
					const result = await this.$request.init({
						method: 'post'
						, url: 'main/postGradeConfirm'
						, data: {
							uid: uid
						}
					})

					if(!result.success){
						throw result.message
					}
				}catch (e) {
					console.log(e)
				}finally {
					this.$bus.$emit('setUser', [{key: 'last_grade', val: ''}])
					this.onGrade()
				}
			}
		}
		,created: function(){
console.log('layout', this.user)
			this.getData()

			this.$bus.$on('on', (type) =>{
				if(type){
					this.onLoading()
				}else{
					this.offLoading()
				}
			})

			this.$bus.$on('onLoad', (program) => {
				this.setProgram(program)
			})

			this.onGrade()


			this.$bus.$on('download', (type, folder, file) => {
				// console.log(type, folder, file)

				let location = window.location.hostname
				let base_url = ''
				if(location.indexOf('localhost') > -1){
					base_url = process.env.VUE_APP_DEV
				}else{
					base_url = '/shop_api'
				}
				window.open(base_url + '/global/download?type=' + type + '&folder=' + folder + '&file_name=' + file, "thumb")
			})
		}
		,watch: {
			$route(){
				this.is_side = false
				this.onGrade()
				this.getData()
			}

			, user: {
				handler: function(){
					this.getData()
				}
			}
		}
	}
	
</script>
<style>

@import "../../assets/css/reset.css";
@import "../../assets/css/template.css";
@import "../../assets/css/base.css";
@import "../../assets/css/template_y.css";
@import "../../assets/css/style_y.css";
</style>